import {
	Select,
	Text,
	Upload,
	Number,
	FormGroupInterface,
	FORM_TYPE,
	VALIDATION_TYPE,
	Textarea,
	S3URLS
} from '../../types';

export function getAddSectorForm(data: any = {}, on: any = {}, required: any = {}, hide: any = {}) {
	const addSectorForm: FormGroupInterface = {
		label: '',
		backButton: true,
		row: false,
		submitText: (data.label && data.label.submit) || 'Submit',
		cancelText: (data.label && data.label.cancel) || 'Cancel',
		type: FORM_TYPE.MODAL,
		forms: [
			{
				formElements: [
					new Select('Select Sector', data.sectorOptions || [], {
						name: 'sector',
						required: true,
						placeholder: 'Select Sector',
						row: false,
						onChange: on.sectorChange
					}),
					new Textarea('Associated Sector Skill Councils:', {
						name: 'associatedSectorSkillCouncils',
						readOnly: true,
					}),
					new Number('Proposed Training Target:', {
						name: 'proposedTrainingTarget',
						required: true,
						row: false,
						validationType: VALIDATION_TYPE.TRAINING_TARGET,
						maxFieldLength: 7,
						minFieldLength: 1,
						min: 1,
						max: data.maxTargetLimit ? data.maxTargetLimit : 1999999
					}),
					new Upload('Upload Undertaking Documents:', {
						name: 'supportingDocuments',
						documentTemplateUrl: S3URLS.SECTOR.ADDITION_REQUEST_INFO,
						isPublicUrl: true,
						multi: true,
						hide: hide.hide,
						required: hide.hide === true ? false : required.supportingDocuments,
						showAstrisk: hide.hide === true ? false : required.supportingDocuments,
						disabled: hide.hide,
						row: false,
						onChange: on.uploadSupportingDocumentChange,
						allowedFormats: ['pdf', 'jpeg', 'png', 'jpg', 'xlsx']
					}),
					new Upload('Upload Affiliation Certificates from SSC:', {
						name: 'affiliationCertificatesFromSSC',
						documentTemplateUrl: S3URLS.SECTOR.SELF_DECLARATION,
						isPublicUrl: true,
						multi: true,
						hide: hide.hide,
						disabled: hide.hide,
						required: hide.hide === true ? false : required.affiliationCertificatesFromSSC,
						showAstrisk: hide.hide === true ? false : required.affiliationCertificatesFromSSC,
						row: false,
						allowedFormats: ['pdf', 'jpeg', 'png', 'jpg', 'xlsx']
					}),
					new Upload('Upload Work Order:', {
						name: 'workOrder',
						// required: false,
						hide: hide.hide,
						disabled: hide.hide,
						row: false,
						// onChange: on.uploadSupportingDocumentChange,
						allowedFormats: ['pdf', 'jpeg', 'png', 'jpg', 'xlsx']
					}),
					new Upload('Upload Challan of the Fee Paid:', {
						name: 'challanOfFeePaid',
						// required: false,
						hide: hide.hide,
						disabled: hide.hide,
						row: false,
						// onChange: on.uploadSupportingDocumentChange,
						allowedFormats: ['pdf', 'jpeg', 'png', 'jpg', 'xlsx']
					})
				]
			}
		]
	};
	// if (required.document) {
	// 	addSectorForm.forms[0].formElements.push(
	// 		new Upload('Upload Supporting Documents:', {
	// 					name: 'supportingDocuments',
	// 					required: true,
	// 					row: false,
	// 					onChange: on.uploadSupportingDocumentChange,
	// 					allowedFormats: ['pdf', 'jpeg', 'png', 'jpg']
	// 				})
	// 	);
	// }
	return addSectorForm;
}
